import Vue from 'vue'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(Mint)

import  'bootstrap'
import  'bootstrap/scss/bootstrap.scss'


import  'font-awesome/css/font-awesome.min.css'

import 'lib-flexible'